import { render, staticRenderFns } from "./InterruptSettingsSection.vue?vue&type=template&id=51a6353b&scoped=true"
import script from "./InterruptSettingsSection.vue?vue&type=script&lang=js"
export * from "./InterruptSettingsSection.vue?vue&type=script&lang=js"
import style0 from "./InterruptSettingsSection.vue?vue&type=style&index=0&id=51a6353b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6353b",
  null
  
)

export default component.exports